module.exports = __webpack_public_path__ + "img/file-break-fill.58d81210.svg";